import type { PayloadAction } from '@reduxjs/toolkit';

import { CampaignConfig, SET_CAMPAIGN_CONFIG } from './types';

const initialState: CampaignConfig | null = null;

export function campaignConfigReducer(
	state = initialState,
	action: PayloadAction<CampaignConfig | null>,
): CampaignConfig | null {
	switch (action.type) {
		case SET_CAMPAIGN_CONFIG:
			return action.payload;
		default:
			return state;
	}
}
